interface PeriodNavProps {
  label: string;
  onPrev: () => void;
  onNext: () => void;
  isPrevLoading?: boolean;
  isNextLoading?: boolean;
}

export function PeriodNav({ label, onPrev, onNext }: PeriodNavProps) {
  return (
    <nav className="approvals-period-nav" aria-label="Week navigation">
      <button type="button" className="arrow" onClick={onPrev} aria-label="Previous week">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path
            d="M10 12L6 8l4-4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <span className="period-label">{label}</span>
      <button type="button" className="arrow" onClick={onNext} aria-label="Next week">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path
            d="M6 4l4 4-4 4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </nav>
  );
}
